<div class="edit-section" [ngClass]="{'edit-section-delete': selectedRecord&&selectedRecord[toDeleteCol], 'edit-section-disabled': disableEditing}">
	<div class="operation-section">
		<div class="card-button-group"> <!-- *ngIf="displayMode==='edit'" -->
			<button class="button-general" [disabled]="displayMode!=='edit'||!editRecordList.length" (click)="discard()">Discard</button>
			<button class="button-general" [title]="commitDisableReason" [disabled]="checkCommitDisabled()" (click)="commit()">Commit</button>
		</div>
	</div>
	<div class="edit-top">
		<div *ngIf="selectedRecord" class="delete-rec-wrap">
			<i *ngIf="!selectedRecord[toDeleteCol]" class="glyphicons glyphicons-bin" (click)="onChangeDelete(true)"></i>
			<button *ngIf="selectedRecord[toDeleteCol]" class="btn-1" (click)="onChangeDelete(false)">Undelete</button>
		</div>
		<div class="edit-control-wrap">
			<div *ngIf="selectedRecord" class="edit-control" [ngClass]="{'first-record': currentList.indexOf(selectedRecord)<=0, 'last-record':currentList.indexOf(selectedRecord)>=currentList.length-1}">
				<div class="go-prev">
					<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
				</div>
				<div class="card-index">
					{{currentList.indexOf(selectedRecord) + 1}} / {{currentList.length}}
				</div>
				<div class="go-next">
					<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
				</div>
			</div>
			<div *ngIf="editRecordList.length" class="slide-switch">
				<label>Selected ({{selectionList.length}})</label>
					<mat-slide-toggle
						class="unbiased-slide-toggle"
						[(ngModel)]="isEditedListCurrent"
						(change)="changeDisplayMode()">
					</mat-slide-toggle>
				<label>Edited ({{editRecordList.length}})</label>
			</div>
			<!-- <div *ngIf="selectedRecord&&selectedRecord[this.isEditedCol]" class="edit-control" [ngClass]="{'first-record': editRecordList.indexOf(selectedRecord)===0, 'last-record':editRecordList.indexOf(selectedRecord)===editRecordList.length-1}">
				<div class="go-prev">
					<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
				</div>
				<div class="card-index">
					{{editRecordList.indexOf(selectedRecord) + 1}} / {{editRecordList.length}}
				</div>
				<div class="go-next">
					<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
				</div>
			</div>
			<div *ngIf="!selectedRecord||!selectedRecord[this.isEditedCol]" class="edit-control first-record" [ngClass]="{'last-record': !this.editRecordList.length}">
				<div class="go-prev">
					<i class="glyphicons glyphicons-chevron-left" (click)="goPrevRecord()"></i>
				</div>
				<div class="card-index">
					0 {{editRecordList.length ? ' / ' + editRecordList.length : ''}}
				</div>
				<div class="go-next">
					<i class="glyphicons glyphicons-chevron-right" (click)="goNextRecord()"></i>
				</div>
			</div> -->
		</div>


		<!-- <div *ngIf="!hideAddButton" class="add-rec-wrap" title="Add a new point">
			<i class="glyphicons glyphicons-plus-sign" (click)="addCard()"></i>
		</div> -->
		<mat-icon *ngIf="showCarryAttrTool" class="add-rec-wrap icon-general" [ngClass]="{'icon-selected': isCarryingAttr}" style="padding:5px;" (click)="onClickCarryAttr()" svgIcon="icon-paint"></mat-icon>
		<!-- <div *ngIf="showCarryAttrTool" class="add-rec-wrap icon-general" [ngClass]="{'icon-selected': isCarryingAttr}">
			<i class="glyphicons glyphicons-brush" (click)="onClickCarryAttr()"></i>
		</div> -->
	</div>
	<div *ngIf="selectedRecord" class="edit-content" [ngClass]="{'delete-record': selectedRecord[toDeleteCol], 'edited-record': selectedRecord[this.isEditedCol]}">
		<div *ngIf="!selectedRecord[isIdOnlyKey]" class="edit-row-group">
			<ng-container *ngFor="let col of columns;let idx = index;">
				<div *ngIf="col.isDisplay!==false && !col.info.hideFromEditing" class="edit-row">
					<div class="edit-column same-line" appHtmlTooltip [tooltip]="col.info.tooltip">
						<div style="flex-grow: 1;">{{col.name}}</div>
						<mat-icon *ngIf="col.info.isFishbone" class="icon-general icon-fishbone" svgIcon="icon-fishbone" matTooltip="Fishbone attribute"></mat-icon>
					</div>
					<div class="edit-value" title="{{selectedRecord[col.prop]}}" [ngClass]="{'field-dirty': checkFieldDirty(col)}">
						<app-feat-edit-cell *ngIf="col.info.standardColName!==nguidStandardCol||selectedRecord[col.prop]"
							[(cellValue)]="selectedRecord[col.prop]"
							[column]="{prop: col.prop, isUppercase: col.info.isUppercase, neighborList: col.info.neighborList}"
							[domainsByColumn]="domainsByColumn"
							[standardColName]="col.info.standardColName"
							[isEditDisabled]="checkCellEditDisable(col)"
							[cssClass]="{
								'qc-exception-cell': checkQcClass(col, 'exception'),
								'qc-warning-cell': checkQcClass(col, 'warning'),
								'qc-error-cell': checkQcClass(col, 'error')
							}"
							[modelKey]="modelKey"
							(valueChange)="onChange(col)"
						></app-feat-edit-cell>

						<app-feat-config-nguid *ngIf="col.info.standardColName===nguidStandardCol&&!selectedRecord[col.prop]" [calculateOnly]="true"></app-feat-config-nguid>
						<div class="anchor-icon" (mouseenter)="onMouseenterAnchor(col)" (mouseleave)="onMouseleaveAnchor(col)">
							<i *ngIf="col.isAnchored||(col.mouseoverAnchor&&!disableEditing)" class="glyphicons glyphicons-anchor" [ngClass]="{'anchored-icon': col.isAnchored}" (click)="toggleAnchor(col)"></i>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
		<div *ngIf="selectedRecord[isIdOnlyKey]">
			<div class="edit-row">
				<div class="edit-column">ID</div>
				<div class="edit-value">
					<input disabled name="idCol" [value]="getRecordId(selectedRecord)">
				</div>
			</div>
		</div>
	</div>
</div>